import { configureStore, TypedStartListening } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import { persistStore, persistReducer } from "redux-persist";

// @ts-ignore
import { addFormSubmitSagaTo } from "redux-form-submit-saga";
import createRootReducer from "./reducers";
import bmApiService from "@/services/bmApi";
import { authListener } from "./reducers/authenticate";
import { createHashHistory } from "history";
import { configurationListener } from "./reducers/configuration";
import { routerMiddleware } from "connected-react-router";
import googleAnalyticsMiddleware from "@/middlewares/googleAnalytics";
import googleTagManagerMiddleware from "@/middlewares/googleTagManager";
import facebookPixelMiddleware from "@/middlewares/facebookPixel";
import { sagas } from "@/sagas/index";
import { PersistedState } from "./types";
import { createIframeStorage } from "./misc/createIframeStorage";
import articleSlice, { articleListener } from "./reducers/article";
import { listener as pincodeListener } from './reducers/pincode';
import { createLogger } from 'redux-logger';
import { getPersistConfig } from 'redux-deep-persist';
import flexibleHoursSlice from "./reducers/flexibleHours";
import articlesSlice from "./reducers/articles";
import embedSlice from "./reducers/embed";
import stripeSlice from "./reducers/stripeSlice";



export const storage = createIframeStorage();


export const history = createHashHistory();



export type LoadEntity = {
  isLoaded: boolean;
  isError: boolean;
  isLoading: boolean;
};

export type authenticateInitialState = LoadEntity & {
  isLoggedIn: boolean;
  error: any;
  state?: PersistedState;
  persist?: {
    rehydrated: boolean,
  }
};

type User = {
  CompanyId?: string;
  Id?: string;
  Firstname?: string;
  Lastname?: string;
  Email?: string;
  WorkerId?: string;
  Phone?: string;
};

export type authoriseInitialState = LoadEntity & {
  error: any;
};

export type UiInitialState = {
  parentScrollTop: number;
}

export const createStoreWithInitialState = (initialState?: any, routerHistory = history) => {
  const rootReducer = createRootReducer(routerHistory);
  const sagaMiddleware = createSagaMiddleware();

  let middlewares: any[] = [
    // createLogger({
      // collapsed: true,
      // predicate: (s, a) => a && a.type && (
      //   a.type.toLowerCase().includes("router")
      // )
      // predicate: (s, a) => a && a.type && !(
      //   a.type.toLowerCase().includes("ui/") ||
      //   a.type.toLowerCase().includes("bmapi")
      // ),
      // @ts-ignore
      // predicate: (s, a) =>
      //   a &&
      //   a.type &&
      //   (a.type.toLowerCase().includes("keycloak") ||
      //     a.type.toLowerCase().includes("state") ||
      //     a.type.toLowerCase().includes("authenticate") ||
      //     a.type.toLowerCase().includes("authorise") ||
      //     a.type.toLowerCase().includes("customer") || 
      //     a.type.toLowerCase().includes("persist") ||
      //     a.type.toLowerCase().includes("service") ||
      //     a.type.toLowerCase().includes("times") ||
      //     a.type.toLowerCase().includes("checkout") ||
      //     a.type.toLowerCase().includes("articles") || 
      //     a.type.toLowerCase().includes("promo") ||
      //     a.type.toLowerCase().includes("price") ||
      //     a.type.toLowerCase().includes("booking") ||
      //     a.type.toLowerCase().includes("router")
      //   ),
      // stateTransformer(state: ApplicationState) {
        
      //   // console.dir(window.location.href);
      //   // @ts-ignore
      //   return {
      //     articleIdsToShow: state.configuration?.data.articleIdsToShow,
      //     serviceIdsToShow: state.configuration?.data.serviceIdsToShow
      //   };
      // },
    // }),
    sagaMiddleware,
  ];

  if (process.env.REACT_APP_ENVIRONMENT === 'prod') {
    middlewares = [
      ...middlewares,
      googleTagManagerMiddleware,
      googleAnalyticsMiddleware,
      facebookPixelMiddleware,
    ];
  }

  const persistConfig = getPersistConfig({
    key: "bm-embed-root",
    storage,
    rootReducer,
    whitelist: [
      'router',
      'booking',
      'checkout',
      'company',
      'configuration',
      'prices',
      'user',
      'createAccount',
      'messages',
      'form.customFields',
      flexibleHoursSlice.name,
      articleSlice.name,
      articlesSlice.name,
      embedSlice.name,
      stripeSlice.name,
    ],
    timeout: 0
  })

  const persistedReducer = persistReducer(
    persistConfig,
    rootReducer
  );

  const store = configureStore({
    devTools: {
      name: `eb-${process.env.REACT_APP_ENVIRONMENT.toLowerCase()}`,
      actionsDenylist: process.env.REACT_APP_ENVIRONMENT.toLowerCase() === 'prod' ? [
        '@@router',
        '@@redux-form/UNREGISTER_FIELD',
        '@@redux-form/REGISTER_FIELD',
        '@@redux-form/INITIALIZE',
        '@@redux-form/FOCUS',
        '@@redux-form/BLUR',
        '@@redux-form/TOUCH',
        // 'stripe',
        'bmApi',
        'persist',
        'auth',
        'pincode'
      ] : [
        '@@router',
        '@@redux-form/UNREGISTER_FIELD',
        '@@redux-form/REGISTER_FIELD',
        '@@redux-form/INITIALIZE',
        '@@redux-form/FOCUS',
        '@@redux-form/BLUR',
        '@@redux-form/TOUCH',
        // 'stripe',
        'bmApi',
        'persist',
        'ui'
      ]
    },
    preloadedState: initialState,
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => [
      ...getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: false,
      }).prepend(
        routerMiddleware(routerHistory),
        bmApiService.middleware,
        ...middlewares,
        authListener.middleware,
        articleListener.middleware,
        configurationListener.middleware,
        pincodeListener.middleware
      ),
    ],
  });

  let persistor = persistStore(store);

  sagaMiddleware.run(addFormSubmitSagaTo(sagas));

  return { store, persistor };
};

export const { store, persistor } = createStoreWithInitialState();

export type ApplicationDispatch = ReturnType<
  typeof createStoreWithInitialState
>["store"]["dispatch"];

export type ApplicationState = ReturnType<
  ReturnType<typeof createStoreWithInitialState>["store"]["getState"]
>;

export type TypedListener = TypedStartListening<ApplicationState, ApplicationDispatch>;



